import React, {useRef, useState} from 'react';
import {Alert, Button, Form} from 'react-bootstrap';
import {respondToReconciliation} from '../../../../services/ReconciliationActionService';

export default function ReconciliationQuestion({companyId,workId,question,onAnswered}) {
    const [answer,setAnswer]=useState(''),[busy,setBusy]=useState(false),[error,setError]=useState(''),[sent,setSent]=useState(false);
    const delivery=useRef(null);
    const submit=async event=>{
        event.preventDefault();if(!answer.trim()||busy)return;
        setBusy(true);setError('');
        if(!delivery.current || delivery.current.answer!==answer) delivery.current={responseId:crypto.randomUUID(),answer};
        try {
            await respondToReconciliation(companyId,workId,{questionId:question.questionId,bankGeneration:question.bankGeneration,
                answerVersion:question.answerVersion,...delivery.current});
            setSent(true);onAnswered?.();
        } catch(e) {setError(e.response?.status===409?'Frågan har ändrats eller är redan hanterad. Uppdatera ärendet.':'Svaret kunde inte skickas. Försök igen.');}
        finally {setBusy(false);}
    };
    if(sent)return <p role="status">Svaret är sparat. Mats fortsätter när ärendet kan köras.</p>;
    return <Form onSubmit={submit} className="my-3">
        <Form.Label htmlFor={`answer-${question.questionId}`}>{question.prompt}</Form.Label>
        <Form.Control as="textarea" id={`answer-${question.questionId}`} value={answer} maxLength={8000} onChange={e=>setAnswer(e.target.value)} disabled={busy}/>
        <Form.Text>Svaret kompletterar underlaget. Det är inget godkännande att bokföra.</Form.Text>
        {error && <Alert variant="warning" className="mt-2">{error}</Alert>}
        <div><Button type="submit" className="mt-2" disabled={busy||!answer.trim()}>{busy?'Sparar…':'Skicka svar'}</Button></div>
    </Form>;
}
